import type { SVGProps } from 'react';

export function ScopeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="32" cy="32" r="20" stroke="currentColor" strokeWidth="2" />
      <path d="M12 32L52 32" stroke="currentColor" strokeWidth="2" />
      <path
        d="M32 12C38 18 42 24 42 32C42 40 38 46 32 52"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M32 12C26 18 22 24 22 32C22 40 26 46 32 52"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
